module.exports = __webpack_public_path__ + "img/xzBg1.7b1bd1bb.png";